export const formatPlacaVeiculo = (placa) => {
  if (!placa) return "";
  if (/^[A-Z]{3}[0-9]{4}$/.test(placa)) {
    return placa.replace(/^([A-Z]{3})([0-9]{4})$/, "$1-$2");
  }
  if (/^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(placa)) {
    return placa.replace(/^([A-Z]{3})([0-9][A-Z][0-9]{2})$/, "$1-$2");
  }
  return placa;
};
